module.exports = __webpack_public_path__ + "biao10.gif?467f25d";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/biao/biao10.gif
 ** module id = 45
 ** module chunks = 0
 **/